<template>
  <div>
    <Table
      class="table-rentals-data"
      :columns="columns"
      :data-source="rentalsData"
      :pagination="pagination"
      @change="handleTableChange"
    >
      <template slot="operation" slot-scope="text, record, index">
        <div class="row-actions">
          <div @click="editRental(record.rental)" class="rentals-edit">
            <img src="../../assets/rentalButtonIcons/edit.svg" />
          </div>
          <div @click="toDelete(record.rental)" class="rentals-delete">
            <img src="../../assets/rentalButtonIcons/delete.svg" />
          </div>
        </div>
      </template>
    </Table>
  </div>
</template>

<script>
import calls from '../../api/calls'
import moment from 'moment'
import DeletePopup from '../../components/GenericDeletePopup.vue'
import { Table } from 'ant-design-vue'
import rentalApi from '../../api/rental'

export default {
  name: 'List',
  components: {
    // DeleteModal
    DeletePopup,
    Table
  },
  props: {
    selectedProperties: Array,
    section: Number
  },
  data() {
    return {
      deleting: false,
      selRental: null,
      columns: [
        {
          title: 'Housemate',
          dataIndex: 'housemateName',
          key: 'housemateName',
          width: 150
        },
        {
          title: 'Room',
          dataIndex: 'roomName',
          key: 'roomName',
          width: 100
        },
        {
          title: 'Arrival',
          dataIndex: 'arrival',
          key: 'arrival',
          sorter: (a, b) => a.arrival.length - b.arrival.length,
          width: 130
        },
        {
          title: 'Departure',
          dataIndex: 'departure',
          key: 'departure',
          sorter: (a, b) => a.departure.length - b.departure.length,
          width: 130
        },
        {
          title: 'Confirmation Code',
          dataIndex: 'confirmationCode',
          key: 'confirmationCode',
          width: 150
        },
        {
          title: 'Channel',
          dataIndex: 'channel',
          key: 'channel',
          width: 130
        },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          width: 100,
          scopedSlots: { customRender: 'operation' }
        }
      ],
      rentalsData: [],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 1
      },
      sort: {
        column: '',
        order: ''
      }
    }
  },
  methods: {
    resetParams() {
      this.pagination.current = 1
      this.pagination.pageSize = 10
      this.pagination.total = 1
    },
    handleTableChange(pagination, filters, { columnKey, order }) {
      this.sortTable(columnKey, order)
      this.pagination = { ...pagination }
      this.getTableData()
    },
    sortTable(columnKey, order) {
      if (!order) {
        this.sort.column = ''
        this.sort.order = ''
      } else {
        this.sort.column = columnKey
        this.sort.order = order === 'ascend' ? 'asc' : 'desc'
      }
    },
    toDelete(rental) {
      this.deleting = true
      this.selRental = rental
    },
    async getTableData() {
      const page = this.pagination.current
      const pageSize = this.pagination.pageSize
      let time = 'upcoming'
      if (this.section === 2) {
        time = 'active'
      }
      const rentals = await rentalApi.getHousemates({
        page,
        perPage: pageSize,
        searchValue: this.searchInput,
        sort: this.sort.column,
        sortBy: this.sort.order,
        time,
        propertyIds:
          this.selectedProperties.length > 0
            ? this.selectedProperties.join(',')
            : ''
      })

      if (rentals?.error) {
        this.$notify({
          group: 'rent-mgt-notification',
          type: 'error',
          text: rentals.error.message
        })
        return
      }
      if (!rentals?.data) return

      this.rentalsData = []
      rentals.data.map((element) => {
        element[2].arrivalOriginal = element[2].arrival
        element[2].departureOriginal = element[2].departure

        const arrival = element[2].arrival.split('T')[0]
        const departure = element[2].departure.split('T')[0]
        const rental = {
          uuid: element[3].uuid,
          housemateName: element[3].name,
          roomName: element[0].name + ' ' + element[1].name,
          arrival: moment
            .utc(arrival)
            .local(true)
            .format('ddd MMM D YYYY')
            .toString(),
          departure: moment
            .utc(departure)
            .local(true)
            .format('ddd MMM D YYYY')
            .toString(),
          confirmationCode: element[2].confirmationCode,
          channel: element[2].channel,
          rental: element
        }
        this.rentalsData.push(rental)
      })
      this.pagination.total = rentals.total_all_data
    },
    createRental() {
      this.$emit('create')
    },
    async editRental(item) {
      this.$emit('edit', { ...item })
    },
    cancelDelete() {
      this.deleting = false
    },
    async deleteRental() {
      await calls.DELETE('rental', `${this.selRental[2].confirmationCode}`)
      this.selRental = null
      this.deleting = false
      this.resetParams()
      await this.getTableData()
    }
  },
  watch: {
    section() {
      this.resetParams()
      this.getTableData()
    },
    selectedProperties() {
      this.resetParams()
      this.getTableData()
    }
  },
  async beforeMount() {
    await this.getTableData()
  }
}
</script>

<style scoped>
* {
  cursor: default;
}
.sort-arrows {
  width: 10px;
  margin-left: 5px;
}
.cursor-pointer {
  cursor: pointer;
}
.rentals-list-container {
  display: flex;
  flex-direction: column;
  background-color: #f5f6f8;
  border-bottom-left-radius: 4px;
  border-bottom-right-radius: 4px;
  height: 100vh;
  overflow: scroll;
  background-color: white;
  width: 100%;
}

tbody {
  max-height: 100%;
  overflow-y: auto;
}

thead,
tbody {
  display: block;
}

.rentals-list-header-container,
.rentals-list-items-container {
  display: flex;
  align-items: center;
  line-height: 48px;
  padding-left: 24px;
  padding-right: 24px;
  height: 48px;
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  text-align: left;
  color: #192a3e;
  border-bottom: rgb(0, 0, 0, 0.1) 1px solid;
  background-color: white;
}

td,
th {
  width: 100%;
}

.rentals-list-header-container {
  background: #ebf0e6;
}
.rentals-list-header {
  color: var(--rentalios-dark);
}

.rentals-list-item-edit,
.rentals-list-item-delete,
.rentals-list-header-edit,
.rentals-list-header-delete {
  width: 32px;
  text-align: center;
}

.rentals-list-header-edit,
.rentals-list-header-delete {
  min-width: 32px;
}

.rentals-list-item-edit,
.rentals-list-item-delete {
  background-color: white;
  border: none;
  width: 16px;
  height: 16px;
  padding: 10px;
  cursor: pointer;
}

.empty-rental-screen {
  width: 100%;
  height: 70%;
  padding-top: 5%;
}

.empty-rental-screen img {
  width: 50%;
  height: 50%;
}

.empty-rental-screen div {
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 40px;
}

.empty-rental-screen button {
  background: #66b015;
  border-radius: 4px;
  border: none;
  color: white;
  font-family: Montserrat;
  font-size: 16px;
  height: 40px;
  width: 192px;
}

.overlap-modal .overlap-table,
tr,
td {
  padding-left: 0;
  border: none;
}

.table-rentals-data ::v-deep .ant-table-thead,
.table-rentals-data ::v-deep .ant-table-tbody {
  font-size: 12px;
  padding-right: 15px;
}

.row-actions {
  display: flex;
}
.rentals-edit img,
.rentals-delete img {
  cursor: pointer;
  padding: 4px;
}

@media screen and (max-width: 600px) {
  td,
  th {
    width: 100%;
    white-space: nowrap;
    padding: 0 20px;
  }
}
</style>
